import {Component, inject} from "@angular/core";
import {Store} from "@ngrx/store";
import {ProjectReportActions} from "../../store/deal.actions";
import {selectReports} from "../../store/report/report.selectors";
import {ApiUtil} from "../../../shared/utils/api-util";
import {DocumentMetadata} from "../../../shared/model/document-metadata";

@Component({
    selector: "valumize-previous-reports",
    templateUrl: "./previous-reports.component.html",
    styleUrls: ["./previous-reports.component.scss"],
    standalone: false
})
export class PreviousReportsComponent {
    private readonly store = inject(Store);

    columns = ["name", "creationDate"];
    reports$ = this.store.select(selectReports);

    constructor( ) {
        this.store.dispatch(ProjectReportActions.loadAll());
    }

    documentUrl(document: DocumentMetadata): string {
        return ApiUtil.toApiPath(`/documents/${document.id}/data`);
    }
}
